<script>
    import Fa from 'svelte-fa'
	  import { faUser } from '@fortawesome/free-solid-svg-icons/';

    export let size = 28;
    export let iconSize = "1.5x";
    export let style = "";
    export let pressed = false;
    export let hoverable = false;

    let container;

    export function getBoundingClientRect() {
        return container.getBoundingClientRect();
    }
</script>

<div bind:this={container} class="container" on:click class:hoverable class:pressed style="width: {size}px; height: {size}px; {style}">
    <div class="icon">
        <Fa icon={faUser} color="#8c8987" size={iconSize} />
    </div>
</div>

<style>
	.container {
		display: flex;
    justify-content: center;
    align-items: center;        
		background-color: #d4d2cf;
    border-radius: 50%;
    overflow: hidden;
	}

	.container.hoverable:hover, .container.pressed {
    background-color: #ccc;
	}

  .icon {
    background-color: transparent;
    transform: translateY(3px);
  }
</style>